export default "__VITE_ASSET__Btau0qeR__"